/* Renegade Club v2: popup + contextual mobile prompt + signup. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  if (window.__orcLoaded) { return; }
  window.__orcLoaded = true;

  var K_SUB = 'orc_subscribed', K_DISMISS = 'orc_dismissed_at', K_DISMISS_SESSION = 'orc_dismissed_session', K_SESSION = 'orc_shown', K_PAGEVIEWS = 'orc_pageviews', K_VARIANT = 'orc_reward_variant';
  var doc = document, html = doc.documentElement;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var TYPOS = {
    'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.co': 'gmail.com',
    'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.con': 'hotmail.com',
    'outlok.com': 'outlook.com', 'outlook.con': 'outlook.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.con': 'yahoo.com',
    'iclould.com': 'icloud.com', 'icloud.con': 'icloud.com'
  };

  /* ---------- privacy-gated safe storage (private mode / blocked storage must never break the page) ---------- */
  function preferencesProcessingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.preferencesProcessingAllowed === 'function' && privacy.preferencesProcessingAllowed());
    } catch (e) { return false; }
  }
  function analyticsProcessingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }
  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed());
    } catch (e) { return false; }
  }
  function lsGet(k) { try { return preferencesProcessingAllowed() ? window.localStorage.getItem(k) : null; } catch (e) { return null; } }
  function lsSet(k, v) { try { if (preferencesProcessingAllowed()) { window.localStorage.setItem(k, v); } } catch (e) {} }
  function lsDel(k) { try { if (preferencesProcessingAllowed()) { window.localStorage.removeItem(k); } } catch (e) {} }
  function ssGet(k) { try { return preferencesProcessingAllowed() ? window.sessionStorage.getItem(k) : null; } catch (e) { return null; } }
  function ssSet(k, v) { try { if (preferencesProcessingAllowed()) { window.sessionStorage.setItem(k, v); } } catch (e) {} }
  function ssDel(k) { try { if (preferencesProcessingAllowed()) { window.sessionStorage.removeItem(k); } } catch (e) {} }
  /* Essential UI state: required to honour an explicit minimise action and suppress Club prompts after signup. */
  function essentialLsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function essentialLsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function essentialLsDel(k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  function essentialSsGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function essentialSsSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function essentialSsDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }
  function qsa(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function raf(fn) { (window.requestAnimationFrame || window.setTimeout)(fn, 16); }
  function isSub() { return !!essentialLsGet(K_SUB); }
  var offerVariant = 'gbp5';
  function emit(name, placement) { try { if (!analyticsProcessingAllowed()) { return; } window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: name, placement: placement || 'site', club_reward_variant: offerVariant }); } catch (e) {} }

  /* ---------- URL params. Test helpers: ?or_reset=1 (clear state) and ?or_popup=1 (force popup) ---------- */
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = { get: function () { return null; } }; }
  var testMode = params.get('or_reset') === '1' || params.get('or_popup') === '1';
  if (params.get('or_reset') === '1') { essentialLsDel(K_SUB); lsDel(K_DISMISS); essentialSsDel(K_DISMISS_SESSION); essentialSsDel(K_SESSION); ssDel(K_VARIANT); }

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var modal = doc.getElementById('orc');
  var lastFocus = null, autoDone = false;
  var away = {};

  /* ---------- one consistent reward across every Club surface ---------- */
  function experimentScope() {
    return doc.querySelector('[data-orc-scope][data-orc-market="GB"]');
  }
  function chooseOfferVariant() {
    var scope = experimentScope();
    if (!scope || scope.getAttribute('data-orc-experiment') !== 'true' || !preferencesProcessingAllowed()) { return 'gbp5'; }
    var stored = ssGet(K_VARIANT);
    if (stored === 'gbp5' || stored === 'shipping') { return stored; }
    var percent = parseInt(scope.getAttribute('data-orc-experiment-percent') || '50', 10);
    if (!isFinite(percent)) { percent = 50; }
    percent = Math.max(0, Math.min(100, percent));
    var draw = Math.random() * 100;
    try {
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var values = new Uint32Array(1);
        window.crypto.getRandomValues(values);
        draw = (values[0] / 4294967296) * 100;
      }
    } catch (e) {}
    var variant = draw < percent ? 'shipping' : 'gbp5';
    ssSet(K_VARIANT, variant);
    return variant;
  }
  function activeOffer(scope) {
    scope = scope || experimentScope() || doc.querySelector('[data-orc-scope]');
    var shipping = offerVariant === 'shipping' && scope && scope.getAttribute('data-orc-market') === 'GB';
    return {
      variant: shipping ? 'shipping' : 'gbp5',
      code: scope ? scope.getAttribute(shipping ? 'data-orc-shipping-code' : 'data-orc-gbp5-code') : (shipping ? 'ROUNDUPUK' : 'RENEGADE5'),
      heading: scope ? scope.getAttribute(shipping ? 'data-orc-shipping-heading' : 'data-orc-gbp5-heading') : (shipping ? 'FREE UK DELIVERY. JOIN THE CLUB.' : 'TAKE £5 OFF. JOIN THE CLUB.'),
      terms: scope ? scope.getAttribute(shipping ? 'data-orc-shipping-terms' : 'data-orc-gbp5-terms') : (shipping ? 'UK standard delivery up to £3.50. First order only.' : '£25 minimum order. First order only.'),
      button: shipping ? 'UNLOCK FREE DELIVERY' : 'UNLOCK £5 OFF',
      reward: shipping ? 'FREE UK DELIVERY' : '£5 OFF £25'
    };
  }
  function setFormTags(form, source) {
    if (!form) { return; }
    var tags = form.querySelector('[data-orc-tags]');
    if (!tags) { return; }
    var base = tags.getAttribute('data-orc-base-tags') || 'newsletter,renegade-club';
    var scope = form.closest('[data-orc-scope]');
    var exp = scope && scope.getAttribute('data-orc-experiment') === 'true' ? ',exp_club_reward_' + offerVariant : '';
    tags.value = base + ',src_' + String(source || 'site').replace(/[^a-z0-9_-]/gi, '').toLowerCase() + exp;
  }
  function syncOfferCopy() {
    var gbScope = experimentScope();
    offerVariant = chooseOfferVariant();
    qsa('[data-orc-scope]').forEach(function (scope) {
      if (scope.getAttribute('data-orc-market') !== 'GB') {
        qsa('form[data-orc-form]', scope).forEach(function (form) { setFormTags(form, form.getAttribute('data-orc-source') || 'site'); });
        return;
      }
      var local = activeOffer(scope);
      scope.setAttribute('data-orc-offer', local.variant);
      var brandLedBanner = !!scope.closest('.orc-band');
      qsa('[data-orc-submit]', scope).forEach(function (el) { el.textContent = brandLedBanner ? 'JOIN THE CLUB' : local.button; });
      qsa('[data-orc-offer-terms]', scope).forEach(function (el) { el.textContent = local.terms; });
      qsa('[data-orc-consent-action]', scope).forEach(function (el) { el.textContent = brandLedBanner ? 'join the club' : local.button.toLowerCase(); });
      qsa('form[data-orc-form]', scope).forEach(function (form) { setFormTags(form, form.getAttribute('data-orc-source') || 'site'); });
    });
    if (!gbScope) { return; }
    var offer = activeOffer(gbScope);
    qsa('[data-orc-headline]').forEach(function (el) { el.textContent = offer.heading; });
    qsa('[data-orc-banner-copy]').forEach(function (el) {
      if (!el.closest('[data-orc-market="GB"]')) { return; }
      el.textContent = offer.variant === 'shipping'
        ? 'Get first access to new drops, restocks and Club-only offers. Plus free UK standard delivery on your first eligible order.'
        : 'Get first access to new drops, restocks and Club-only offers. Plus £5 off your first £25 order.';
    });
    qsa('[data-orc-sticky-offer]').forEach(function (el) { el.textContent = offer.reward; });
    qsa('[data-orc-offer-label]').forEach(function (el) {
      var product = el.getAttribute('data-orc-offer-placement') === 'product';
      el.textContent = product ? 'Join the Club — ' + offer.reward + ' on your first order.' : 'JOIN THE RENEGADE CLUB: ' + offer.reward;
    });
  }
  function decorateReward(reward, wrap, source) {
    var offer = activeOffer(wrap);
    var codeNode = reward.querySelector('[data-orc-code]');
    var copy = reward.querySelector('[data-orc-copy]');
    var link = reward.querySelector('[data-orc-reward-link]');
    var codeBox = reward.querySelector('.orc-code');
    var qualified = reward.getAttribute('data-orc-cart-qualified') === 'true';
    var redirect = reward.getAttribute('data-orc-base-redirect') || window.location.pathname || '/collections/all';
    if (source === 'cart') {
      redirect = (offer.variant === 'shipping' || qualified) ? '/checkout' : '/cart';
      if (codeBox) { codeBox.hidden = true; }
    }
    if (codeNode) { codeNode.textContent = offer.code; }
    if (copy) { copy.setAttribute('data-code', offer.code); }
    if (link) {
      var current = link.getAttribute('href') || '/discount/';
      var marker = current.indexOf('discount/');
      var prefix = marker >= 0 ? current.slice(0, marker) : '/';
      link.setAttribute('href', prefix + 'discount/' + encodeURIComponent(offer.code) + '?redirect=' + encodeURIComponent(redirect));
      link.textContent = source === 'cart' && redirect === '/checkout'
        ? 'APPLY REWARD & CHECK OUT'
        : (offer.variant === 'shipping' ? 'APPLY FREE DELIVERY' : 'APPLY £5 OFF');
    }
    return offer;
  }

  /* ---------- analytics (only fires if the tag already exists on the store) ---------- */
  function track(name, source) {
    try {
      if (analyticsProcessingAllowed()) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'orc_' + name, orc_source: source || '' });
        if (name === 'lead' && typeof window.gtag === 'function') {
          window.gtag('event', 'generate_lead', { method: source || 'site' });
        }
      }
      if (name === 'lead' && marketingAllowed() && typeof window.fbq === 'function') {
        window.fbq('track', 'Lead');
      }
    } catch (e) {}
  }

  /* ---------- Club prompt helpers ---------- */
  function retireSticky() {
    var bar = doc.querySelector('[data-or-club-stick]');
    if (bar) { bar.hidden = true; }
  }

  /* ---------- success state ---------- */
  function showSuccess(wrap, focusIt) {
    var box = wrap.querySelector('[data-orc-formbox]');
    var ok = wrap.querySelector('[data-orc-ok]');
    if (box) { box.hidden = true; }
    if (ok) {
      ok.hidden = false;
      if (focusIt) { ok.setAttribute('tabindex', '-1'); try { ok.focus(); } catch (e) {} }
    }
    var root = wrap.closest ? wrap.closest('.orc__panel, .orc-band__in') : null;
    if (root) {
      qsa('[data-orc-intro]', root).forEach(function (el) { el.hidden = true; });
      var no = root.querySelector('.orc-no'); if (no) { no.hidden = true; }
    }
  }
  function showSuccessEverywhere(focusWrap) {
    qsa('[data-orc-scope]').forEach(function (w) {
      var ok = w.querySelector('[data-orc-ok]');
      if (ok && ok.childNodes.length) { showSuccess(w, w === focusWrap); }
      else if (!focusWrap) { w.hidden = true; }
    });
    retireSticky();
  }

  /* ---------- popup open / close ---------- */
  function open(from) {
    if (!modal || !modal.hidden) { return; }
    var modalSource = String(from || 'popup').replace(/[^a-z0-9_-]/gi, '').toLowerCase() || 'popup';
    qsa('form[data-orc-form]', modal).forEach(function (form) {
      form.setAttribute('data-orc-source', modalSource);
      setFormTags(form, modalSource);
    });
    if (!testMode && modal.getAttribute('data-customer') === 'true') { return; }
    lastFocus = doc.activeElement;
    modal.hidden = false;
    html.classList.add('orc-lock');
    raf(function () { modal.classList.add('is-open'); });
    var f = modal.querySelector('input[type="email"]');
    window.setTimeout(function () {
      var target = (f && f.offsetParent !== null) ? f : modal.querySelector('.orc__panel');
      if (target) { try { target.focus(); } catch (e) {} }
    }, 60);
    essentialSsSet(K_SESSION, '1');
    track('view', from || 'popup'); emit('signup_view', from || 'popup');
  }
  function close(dismissed) {
    if (!modal || modal.hidden) { return; }
    modal.classList.remove('is-open');
    html.classList.remove('orc-lock');
    window.setTimeout(function () { modal.hidden = true; }, 200);
    if (dismissed && !isSub()) { essentialSsSet(K_DISMISS_SESSION, '1'); lsSet(K_DISMISS, String(Date.now())); try { initMobileStick(); } catch (e) {} }
    if (window.location.hash === '#renegade-club' && window.history && window.history.replaceState) {
      try { window.history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}
    }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  /* ---------- clicks ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var opener = t.closest('[data-orc-open], a[href$="#renegade-club"]');
    if (opener) {
      e.preventDefault();
      var from = opener.getAttribute('data-orc-from') || 'link';
      if (from === 'stickybar') { track('click', from); }
      open(from);
      return;
    }
    if (t.closest('[data-orc-close]')) { e.preventDefault(); close(true); return; }
    var copy = t.closest('[data-orc-copy]');
    if (copy) {
      var code = copy.getAttribute('data-code') || '';
      var done = function () { copy.textContent = 'COPIED'; window.setTimeout(function () { copy.textContent = 'COPY'; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        try {
          var ta = doc.createElement('textarea'); ta.value = code; ta.setAttribute('readonly', '');
          ta.style.position = 'fixed'; ta.style.opacity = '0'; doc.body.appendChild(ta); ta.select();
          doc.execCommand('copy'); doc.body.removeChild(ta);
        } catch (err) {}
        done();
      }
    }
  }, true);

  doc.addEventListener('keydown', function (e) {
    if (!modal || modal.hidden) { return; }
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') { return; }
    var items = qsa('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])', modal)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) { return; }
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  window.addEventListener('hashchange', function () { if (window.location.hash === '#renegade-club') { open('hash'); } });
  doc.addEventListener('or:cart-opened', function () { if (modal && !modal.hidden) { close(true); } });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) { return; }
    if (modal && modal.hidden) { html.classList.remove('orc-lock'); }
    if (isSub()) { showSuccessEverywhere(null); }
  });
  window.addEventListener('storage', function (e) { if (e.key === K_SUB && e.newValue) { showSuccessEverywhere(null); } });
  doc.addEventListener('or:customer-captured', function () {
    essentialLsSet(K_SUB, String(Date.now()));
    showSuccessEverywhere(null);
  });

  /* ---------- signup (AJAX with native fallback so it can never silently fail) ---------- */
  function setMsg(el, text, isErr) {
    if (!el) { return; }
    el.textContent = text || '';
    el.classList.toggle('is-err', !!isErr);
  }
  function suggestFix(email) {
    var at = email.lastIndexOf('@');
    if (at < 1) { return null; }
    var dom = email.slice(at + 1);
    return Object.prototype.hasOwnProperty.call(TYPOS, dom) ? email.slice(0, at + 1) + TYPOS[dom] : null;
  }

  /* Club sign-ups also go straight to the Klaviyo list that starts the welcome emails.
     Shopify's customer sync alone missed sign-ups (audit E1, Oct 2026). Best effort, never blocks the reward.
     Skipped for automated browsers so QA runs never create real subscribers. */
  var KLAVIYO_COMPANY = 'TMAEHJ', KLAVIYO_LIST = 'ThP8Dn';
  function klaviyoSubscribe(email, source) {
    try {
      if (!window.fetch || (window.navigator && window.navigator.webdriver)) { return; }
      if (/@(example\.(com|org|net)|test\.com)$/.test(email)) { return; }
      window.fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_COMPANY, {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'Renegade Club (' + source + ')',
          profile: { data: { type: 'profile', attributes: { email: email, properties: { renegade_club_source: source } } } },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } } } })
      }).catch(function () {});
    } catch (e) {}
  }

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-orc-form]')) { return; }
    if (!window.fetch || !window.FormData) { return; } /* very old browser: let the native submit happen */
    e.preventDefault();
    if (form.getAttribute('data-orc-busy') === '1') { return; }

    var wrap = form.closest('[data-orc-scope]');
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('[data-orc-submit]');
    var msg = wrap ? wrap.querySelector('[data-orc-msg]') : null;
    var source = form.getAttribute('data-orc-source') || 'site';
    var trap = form.querySelector('[name="orc_website"]');

    if (trap && trap.value) { return; } /* honeypot: bot */

    var email = ((input && input.value) || '').trim().toLowerCase();
    if (!EMAIL_RE.test(email) || email.length > 254) {
      setMsg(msg, 'Enter a valid email address.', true);
      if (input) { input.focus(); }
      return;
    }
    if (input) { input.value = email; }

    var fix = suggestFix(email);
    if (fix && form.getAttribute('data-orc-typo-offered') !== '1') {
      form.setAttribute('data-orc-typo-offered', '1');
      if (input) { input.value = fix; input.focus(); }
      setMsg(msg, 'Fixed a typo: ' + fix + '. Tap again to confirm.', false);
      return;
    }

    emit('signup_submit', source);
    if (window.navigator && window.navigator.onLine === false) {
      setMsg(msg, 'You appear to be offline. Check your connection and try again.', true);
      return;
    }

    setMsg(msg, '', false);
    form.setAttribute('data-orc-busy', '1');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    function unbusy() {
      form.removeAttribute('data-orc-busy');
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }

    var ctrl = window.AbortController ? new window.AbortController() : null;
    var timer = window.setTimeout(function () { if (ctrl) { ctrl.abort(); } }, 12000);

    window.fetch(form.action, {
      method: 'POST', body: new FormData(form), credentials: 'same-origin',
      headers: { Accept: 'text/html' }, signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (res) {
        window.clearTimeout(timer);
        /* Shopify sometimes serves a captcha challenge: hand over to a normal submit so the person can pass it */
        if (res.url && res.url.indexOf('/challenge') !== -1) { var c = new Error('challenge'); c.challenge = true; throw c; }
        if (!res.ok) { throw new Error('status ' + res.status); }
        return res.text();
      })
      .then(function (body) {
        var parsed = new window.DOMParser().parseFromString(body, 'text/html');
        var success = null;
        qsa('[data-or-server-success]', parsed).some(function (candidate) {
          if ((candidate.getAttribute('data-or-source') || '') === source) { success = candidate; return true; }
          return false;
        });
        if (!success) { success = parsed.querySelector('[data-or-server-success]'); }
        if (!success) {
          var serverError = parsed.querySelector('[data-or-server-error]');
          var err = new Error('signup not confirmed');
          err.serverMessage = serverError ? (serverError.textContent || '').replace(/\s+/g, ' ').trim() : '';
          throw err;
        }
        var reward = success.content ? success.content.cloneNode(true) : success.cloneNode(true);
        var ok = wrap ? wrap.querySelector('[data-orc-ok]') : null;
        if (!reward || !ok) { throw new Error('confirmed reward missing'); }
        decorateReward(reward, wrap, source);
        ok.innerHTML = '';
        ok.appendChild(reward);
        essentialLsSet(K_SUB, String(Date.now()));
        klaviyoSubscribe(email, source);
        unbusy();
        showSuccessEverywhere(wrap);
        track('lead', source); emit('signup_success', source);
      })
      .catch(function (err) {
        window.clearTimeout(timer);
        unbusy();
        if (err && err.challenge) { form.submit(); return; }
        setMsg(msg, (err && err.name === 'AbortError')
          ? 'That took too long. Check your connection and try again.'
          : (err && err.serverMessage ? err.serverMessage : 'We could not confirm that signup. Check the email and try again.'), true);
      });
  }, true);

  /* ---------- popup: automatic triggers ---------- */
  function skipAuto() {
    try {
      if (window.top !== window.self) { return true; }               /* inside an iframe (e.g. editor preview) */
      if (window.navigator && window.navigator.webdriver) { return true; } /* audits / bots */
    } catch (e) { return true; }
    var med = (params.get('utm_medium') || '').toLowerCase();
    var paid = /^(paid|cpc|ppc|display|social_paid|paid_social)$/.test(med) || params.get('gclid') || params.get('fbclid');
    var views = parseInt(essentialSsGet(K_PAGEVIEWS) || '0', 10);
    return params.get('orc_skip') === '1' || med === 'email' || med === 'sms' || (!!paid && views <= 1); /* arriving from your own emails = already a subscriber */
  }
  function eligible() {
    if (isSub()) { return false; }
    if (essentialSsGet(K_DISMISS_SESSION)) { return false; }
    var days = parseFloat(modal.getAttribute('data-cooldown')) || 7;
    var last = parseInt(lsGet(K_DISMISS) || '0', 10);
    if (last && Date.now() - last < days * 864e5) { return false; }
    if (essentialSsGet(K_SESSION)) { return false; }
    return true;
  }
  function armAuto() {
    var delay = (parseInt(modal.getAttribute('data-delay'), 10) || 10) * 1000;
    var pct = parseInt(modal.getAttribute('data-scroll'), 10) || 40;
    var timer = null, leaveTimer = null, ticking = false, tries = 0;

    function cleanup() {
      window.clearTimeout(timer); window.clearTimeout(leaveTimer);
      window.removeEventListener('scroll', onScroll);
      doc.removeEventListener('mouseout', onLeave);
    }
    function blocked() {
      var a = doc.activeElement;
      if (a && a !== doc.body && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !modal.contains(a)) { return true; }
      return qsa('dialog[open], [aria-modal="true"]').some(function (el) {
        return el !== modal && el.offsetWidth > 0 && el.offsetHeight > 0 && window.getComputedStyle(el).visibility !== 'hidden';
      });
    }
    function fire() {
      if (autoDone) { return; }
      if (!eligible()) { autoDone = true; cleanup(); return; }
      if (blocked()) {
        if (tries < 3) { tries++; timer = window.setTimeout(fire, 6000); }
        else { autoDone = true; cleanup(); }
        return;
      }
      autoDone = true; cleanup(); open('popup');
    }
    function onScroll() {
      if (ticking) { return; } ticking = true;
      raf(function () {
        ticking = false;
        var max = html.scrollHeight - window.innerHeight;
        if (max > 0 && (window.pageYOffset / max) * 100 >= pct) { fire(); }
      });
    }
    function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0) { fire(); } }

    timer = window.setTimeout(fire, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      leaveTimer = window.setTimeout(function () { doc.addEventListener('mouseout', onLeave); }, 5000);
    }
  }
  function initPopup() {
    if (params.get('or_popup') === '1') { window.setTimeout(function () { open('forced'); }, 500); return; }
    if (window.location.hash === '#renegade-club') { open('hash'); return; }
    if (params.get('or_popup') === '0') { return; }
    if (modal.getAttribute('data-auto') !== 'true') { return; }
    if (!testMode && (modal.getAttribute('data-customer') === 'true' || skipAuto())) { return; }
    if (eligible()) { armAuto(); }
  }

  /* ---------- mobile shopping sticky ---------- */
  function initMobileStick() {
    var bar = doc.querySelector('[data-or-club-stick]');
    if (!bar || isSub() || bar.getAttribute('data-orc-stick-ready') === '1') { return; }
    bar.setAttribute('data-orc-stick-ready', '1');
    var dismissed = false, ticking = false;
    var closeBtn = bar.querySelector('[data-or-club-stick-close]');
    if (closeBtn) { closeBtn.addEventListener('click', function () { dismissed = true; bar.hidden = true; }); }
    function check() {
      if (dismissed || !(window.matchMedia && window.matchMedia('(max-width: 759px)').matches)) { bar.hidden = true; return; }
      var max = Math.max(1, html.scrollHeight - window.innerHeight);
      var pageType = bar.getAttribute('data-page-type') || '';
      var shoppingPage = /^(product|collection)$/.test(pageType);
      var dismissedPopup = !!essentialSsGet(K_DISMISS_SESSION) || !!lsGet(K_DISMISS);
      /* Product pages already have a sticky Add to Cart. Never compete with the purchase control. */
      if (pageType === 'product') { bar.hidden = true; return; }
      bar.hidden = shoppingPage ? ((window.pageYOffset / max) < .30) : !dismissedPopup;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; raf(function () { ticking = false; check(); }); } }, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  /* ---------- Journal placement: move the capture after paragraph three when available ---------- */
  function initArticleClub() {
    var club = doc.querySelector('[data-or-article-club]');
    var copy = doc.querySelector('[data-or-article-copy]');
    if (!club || !copy || club.getAttribute('data-orc-placed') === '1') { return; }
    var paragraphs = copy.querySelectorAll('p');
    if (paragraphs.length >= 3) { paragraphs[2].insertAdjacentElement('afterend', club); }
    club.setAttribute('data-orc-placed', '1');
  }

  /* ---------- init (never allowed to break the storefront) ---------- */
  function init() {
    try { syncOfferCopy(); } catch (e) {}
    try { if (isSub()) { showSuccessEverywhere(null); } } catch (e) {}
    try { essentialSsSet(K_PAGEVIEWS, String(parseInt(essentialSsGet(K_PAGEVIEWS) || '0', 10) + 1)); } catch (e) {}
    try { initMobileStick(); } catch (e) {}
    try { initArticleClub(); } catch (e) {}
    try { if (modal) { initPopup(); } } catch (e) {}
  }
  if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
